import styled from 'styled-components';

export const Container = styled.div`
  & #searchResults{
    overflow: scroll;
    height: auto;
  }
  & .FilterSort{
    margin: 0 10px;
    padding-bottom: 12px;
    display: flex;
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid #DADFE6;
  }
  &.SearchResultsItems{
    margin: 86px 20px 50px;
    display: flex;
    flex-direction: column;
    /*@media screen and (min-width: 768px) {
      margin-top: 86px;
    }*/
  }
  & .Sort{
    position: absolute;
    top: -5px;
    right: 15px;
  }
  &.Margin{
    margin-bottom: 40px;
  }
  &.EmptyResults{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }
`;

export const StyledSpan = styled.span`
  &.IconMore{
    margin: 0 auto;
    cursor: pointer;
    border: 1px solid #DADFE6;
    box-sizing: border-box;
    border-radius: 47px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  &.EmptyResultsSpan{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 168%;
    color: #2C2B48;
  }
  &.ShowAllAnchor{
    font-size: 18px;
    line-height: 168%;
    text-decoration: underline;
    cursor: pointer;
    padding-left: 5px;
    color: #1C62EF;
  }
`;

export const StyledImg = styled.img`
  margin-bottom: 50px;
`;

export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 142%;
  color: #2C2B48;
`;

export const StyledH1 = styled.h1`
  text-align: center;
`;

export const VideoContainer = styled.div`
  margin-top: 150px;
  text-align: center;
  & img{
    max-width: 100%;
  }
`

export const PlatformLoader = styled.div`
  margin: 15px 0;
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
  & img:first-child {
    margin-right: 30px;
    //padding-right: 30px;
  }
  & .loading-circle{
    animation: rotate 2s linear infinite;
  }
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & .trova-color {
    color: #1C62EF;
  }
`